// DEPRECATED - Please add new events to packages/notices/events.ts

import { ClientEvent } from '@udemy/event-tracking';
import { NOTICE_TYPE_INSTRUCTOR_BAR, NOTICE_TYPE_SMART_BAR, NOTICE_TYPE_UFB_SMART_BAR } from './bar-types';
export let NoticeType = /*#__PURE__*/function (NoticeType) {
  NoticeType["WEB_BANNER"] = "web_banner";
  NoticeType["FEATURED_BANNER"] = "featured_banner";
  NoticeType["HOME_BANNER"] = "home_banner";
  NoticeType["MOBILE_BANNER"] = "mobile_banner";
  NoticeType[NoticeType["SMART_BAR"] = NOTICE_TYPE_SMART_BAR] = "SMART_BAR";
  NoticeType[NoticeType["UFB_SMART_BAR"] = NOTICE_TYPE_UFB_SMART_BAR] = "UFB_SMART_BAR";
  NoticeType[NoticeType["INSTRUCTOR_BAR"] = NOTICE_TYPE_INSTRUCTOR_BAR] = "INSTRUCTOR_BAR";
  NoticeType["CART_SUCCESS_MESSAGE"] = "cart_success_message";
  NoticeType["PURCHASE_SUCCESS_MESSAGE"] = "purchase_success_message";
  NoticeType["FALLBACK_BANNER"] = "fallback_banner";
  NoticeType["WEB_CAROUSEL_SLIDE"] = "web_carousel_slide";
  return NoticeType;
}({});
export class BannerImpressionEvent extends ClientEvent {
  constructor({
    noticeId = 0,
    noticeType,
    personalizedNoticeSetId = null,
    personalizedNoticeSetName = null,
    topMembershipTargetGroupId = null,
    slideNumber = null
  }) {
    super('BannerImpressionEvent');
    this.noticeId = void 0;
    this.noticeType = void 0;
    this.personalizedNoticeSetId = void 0;
    this.personalizedNoticeSetName = void 0;
    this.topMembershipTargetGroupId = void 0;
    this.slideNumber = void 0;
    this.noticeId = noticeId;
    this.noticeType = noticeType;
    this.personalizedNoticeSetId = personalizedNoticeSetId;
    this.personalizedNoticeSetName = personalizedNoticeSetName;
    this.topMembershipTargetGroupId = topMembershipTargetGroupId;
    this.slideNumber = slideNumber;
  }
}
export class BannerClickEvent extends ClientEvent {
  constructor({
    noticeId = 0,
    noticeType,
    personalizedNoticeSetId = null,
    personalizedNoticeSetName = null,
    topMembershipTargetGroupId = null,
    slideNumber = null,
    url = null,
    uiRegion = null
  }) {
    super('BannerClickEvent');
    this.noticeId = void 0;
    this.noticeType = void 0;
    this.personalizedNoticeSetId = void 0;
    this.personalizedNoticeSetName = void 0;
    this.topMembershipTargetGroupId = void 0;
    this.slideNumber = void 0;
    this.url = void 0;
    this.uiRegion = void 0;
    this.noticeId = noticeId;
    this.noticeType = noticeType;
    this.personalizedNoticeSetId = personalizedNoticeSetId;
    this.personalizedNoticeSetName = personalizedNoticeSetName;
    this.topMembershipTargetGroupId = topMembershipTargetGroupId;
    this.slideNumber = slideNumber;
    this.url = url;
    this.uiRegion = uiRegion;
  }
}
export class SmartbarImpressionEvent extends ClientEvent {
  constructor({
    noticeId = 0,
    noticeType,
    personalizedNoticeSetId = null,
    personalizedNoticeSetName = null,
    topMembershipTargetGroupId = null
  }) {
    super('SmartbarImpressionEvent');
    this.noticeId = void 0;
    this.noticeType = void 0;
    this.personalizedNoticeSetId = void 0;
    this.personalizedNoticeSetName = void 0;
    this.topMembershipTargetGroupId = void 0;
    this.noticeId = noticeId;
    this.noticeType = noticeType;
    this.personalizedNoticeSetId = personalizedNoticeSetId;
    this.personalizedNoticeSetName = personalizedNoticeSetName;
    this.topMembershipTargetGroupId = topMembershipTargetGroupId;
  }
}
export class SmartbarClickEvent extends ClientEvent {
  constructor({
    noticeId = 0,
    noticeType,
    url,
    location = 'action_url',
    personalizedNoticeSetId = null,
    personalizedNoticeSetName = null,
    topMembershipTargetGroupId = null
  }) {
    super('SmartbarClickEvent');
    this.noticeId = void 0;
    this.noticeType = void 0;
    this.personalizedNoticeSetId = void 0;
    this.personalizedNoticeSetName = void 0;
    this.topMembershipTargetGroupId = void 0;
    this.url = void 0;
    this.location = void 0;
    this.noticeId = noticeId;
    this.noticeType = noticeType;
    this.personalizedNoticeSetId = personalizedNoticeSetId;
    this.personalizedNoticeSetName = personalizedNoticeSetName;
    this.topMembershipTargetGroupId = topMembershipTargetGroupId;
    this.url = url;
    this.location = location;
  }
}
export class SmartbarHideEvent extends ClientEvent {
  constructor({
    noticeId = 0,
    noticeType,
    personalizedNoticeSetId = null,
    personalizedNoticeSetName = null,
    topMembershipTargetGroupId = null
  }) {
    super('SmartbarHideEvent');
    this.noticeId = void 0;
    this.noticeType = void 0;
    this.personalizedNoticeSetId = void 0;
    this.personalizedNoticeSetName = void 0;
    this.topMembershipTargetGroupId = void 0;
    this.noticeId = noticeId;
    this.noticeType = noticeType;
    this.personalizedNoticeSetId = personalizedNoticeSetId;
    this.personalizedNoticeSetName = personalizedNoticeSetName;
    this.topMembershipTargetGroupId = topMembershipTargetGroupId;
  }
}
export class DealOptInEvent extends ClientEvent {
  constructor(noticeId = 0) {
    super('DealOptInEvent');
    this.noticeId = void 0;
    this.noticeId = noticeId;
  }
}
//# sourceMappingURL=events.js.map